<script lang="ts">
    
    import { getContext } from "svelte";
    import type { Readable } from "svelte/store";
    import { Alert, Button, Icon } from "sveltestrap";
    import type { Answer } from "../Model/Answer";
    import type { Form } from "../Model/Form";
    import type { FormInstance } from "../Model/FormInstance";
    import type { ReadableStore } from "../Model/ReadableStore";
    import { formValidatorFactory, instancesService, sessionService } from "../Services";

    export let instance: FormInstance;
    export let answersMap: Map<string, Answer>;
    export let form: Form;

    const formValidate = formValidatorFactory.createValidator(form, instance, answersMap);
    const isFulfilled: Readable<boolean> = getContext('isFulfilled');

    let isOwner = false;
    let isFullSigned: ReadableStore<boolean>;
    let isFinished: ReadableStore<boolean>;

    $: setupComponent(instance);

    function setupComponent(instance: FormInstance): void {
        isOwner = instance.hasOwner(sessionService.user.id);
        isFullSigned = instance.isFullSignedReadable;
        isFinished = instance.isFinishedReadable;
    }

    async function onFinish(): Promise<void> {

        if (!(await formValidate.validate())) {
            return;
        }
        
        try {
            
            const dateCompleted = new window.Date();
            await instancesService.finalize(instance.id, dateCompleted);
            instance.setFinished(dateCompleted);

        } catch (error) {
            console.error(error);
        }
    }

</script>

{#if isOwner}

    {#if !$isFulfilled}
        <Alert color="warning">
            <Icon name="exclamation-octagon" /> No han sido respondidas todas las preguntas obligatorias.
        </Alert>
    {/if}

    {#if !$isFullSigned}
        <Alert color="warning">
            <Icon name="exclamation-octagon" /> Aun no ha sido firmado por todos los miembros.
        </Alert>
    {/if}

    {#if $isFinished}
        <Alert color="success">
            <Icon name="check2" /> El formulario ha sido finalizado.
        </Alert>
    {:else}
        <Button type="button" color="success" block disabled={!$isFullSigned || !$isFulfilled} on:click={onFinish}>
            <Icon name="check2" /> Finalizar formulario
        </Button>
    {/if}

{/if}
